import React from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import { Image, Stack, Text, Textarea } from '@mantine/core';
import { Button } from '@mantine/core';
import { FiTrash } from 'react-icons/fi';
import { Card, FormGroup, Input } from 'reactstrap';
import Select from 'react-select/src/Select';
import moment from 'moment';
import { TextArea } from '../../components/textarea';
import { useState } from 'react';

interface ModalRevokeProps {
    data: any;
    title?: string;
    isVisible: boolean;
    cancelText?: string;
    onClose: () => void;
    onConfirmation: () => void;
    reason?: string;
    revokedBinusianId?: string;
    revokedName?: string;
    revokedEmail?: string;
  }

const ModalRevoke: React.FC<ModalRevokeProps> = ({
    isVisible,
    onClose,
    onConfirmation,
    title,
    cancelText,
    data,
    revokedBinusianId,
    revokedEmail,
    revokedName
  }) => {

    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    const handleReasonChange = (val) => {
      if(val === ''){
        setReason('');
        setError('Reason is required');
        return
      }
      setReason(val);
      setError('');
    };

    const handleSubmit = () => {
        if (reason.trim() === '') {
            setError('Reason is required');
            return;
        }
        data.RevokedReason = reason
        data.RevokedBinusianId = revokedBinusianId
        data.RevokedName = revokedName
        data.RevokedBinusianName = revokedName
        data.RevokedEmail = revokedEmail
        data.UserUp = revokedBinusianId
        if(data.deleteText === 'Cancel'){
          if(data.Status === '001'){
            data.Status = '002'
          }
        }else if(data.deleteText === 'Revoke'){
          if(data.Status === '001'){
            data.Status = '003'
          }
        }
        onConfirmation();
    };

    return (
      <ModalWrapper
        title={data.deleteText + ` Delegation`}
        isVisible={isVisible}
        onClose={onClose}
      >
        <div>
          <div>
            <div className='select-wrapper'>
                <p>Delegated Employee Name</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    value={data.DelegatedName}
                    type="text"
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Delegated Task</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.TaskDelegated}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Start Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.StartDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>End Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.EndDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Reason<span style={{ color: 'red' }}>*</span></p>
                <FormGroup>
                    <Input
                    onChange={(e) => (handleReasonChange(e.target.value))}
                    type ="text"
                    />
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </FormGroup>
                           
            </div>
            
            <div className="wrapper-modal-delete__content__actions">
              <Button
                onClick={() => handleSubmit()}
                color='purple'
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </ModalWrapper>
    );
  };

export default ModalRevoke